// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const unifiedLanding = {
  unified_landing_page: {
    carousel_tax_advantaged_text: '税收优惠账户的力量',
    medicare_callout: {
      contentful_name: '[default] Unified Landing Medicare Callout',
      tag: '新品',
      text: '{x}现在可以帮助您了解联邦医疗保险!',
      cta_button: '了解更多关于联邦医疗保险的信息',
      text_primary: '有关联邦医疗保险的问题?',
      text_secondary: 'ALEX也可以帮助解决这个问题',
      cta_button_v2: '了解更多',
    },
    hide_open_enrollment_bar: false,
    open_enrollment_bar_before_oe_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '距离开放注册开始还有 ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'bold',
                },
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ' 天!',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    carousel_header: '更多成为福利专家的方法',
    open_enrollment_bar_days_left_ending_soon_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '仅剩',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'bold',
                },
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '天',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '报名时间!',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    choose_experience_modal: {
      contentful_name: '[default] Unified Landing Choose Experience Modal',
      title: '选择您的{x}体验',
      option1_bullets: ['深入了解您的选择方案', '开启声音效果更佳', '提供隐藏字幕'],
      option2_bullets: ['您的福利简要概述', '无需声音', '包含家庭计划比较工具'],
      button: '继续',
      spanish_support_disclaimer: '仅提供英文版本',
      reviewer_note: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '**致审阅者:**审阅模式在基于音频的体验中不可用。要使用审阅模式,请选择"福利简要概述"选项——同时别忘了也测试基于音频的体验!',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
    },
    alert_banner_enabled: false,
    footer: {
      contentful_name: '[default] Unified Landing Footer',
      disclaimer: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  'ALEX 提供您的福利摘要,并在我们所知范围内确保准确性。这不是注册申请。点击"登录或注册"即表示您同意',
                marks: [],
                data: {},
              },
              {
                nodeType: 'hyperlink',
                data: {
                  uri: 'https://www.jellyvision.com/tos/',
                },
                content: [
                  {
                    nodeType: 'text',
                    value: '服务条款',
                    marks: [
                      {
                        type: 'bold',
                      },
                    ],
                    data: {},
                  },
                ],
              },
              {
                nodeType: 'text',
                value: '和',
                marks: [],
                data: {},
              },
              {
                nodeType: 'hyperlink',
                data: {
                  uri: 'https://www.jellyvision.com/privacy/',
                },
                content: [
                  {
                    nodeType: 'text',
                    value: '隐私政策',
                    marks: [
                      {
                        type: 'bold',
                      },
                    ],
                    data: {},
                  },
                ],
              },
              {
                nodeType: 'text',
                value: '。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      copyright: '© 2008–{x} The Jellyvision Lab, Inc. 保留所有权利。',
      do_not_sell_text: '您的隐私选择',
    },
    alert_banner_content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '警报:',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                ' 由于亚马逊云服务(AWS)出现大范围故障,我们目前正经历间歇性问题,这影响了ALEX的部分功能。感谢您在我们解决此问题期间的耐心与理解。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-1',
          content: [],
          data: {},
        },
      ],
    },
    open_enrollment_bar_days_left_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '还剩 ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'bold',
                },
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ' 天',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '报名!',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    contentful_name: '[default] Unified Landing Page',
    carousel_mental_health_text: '利用福利支持您的心理健康',
    carousel_medical_services_text: '如何货比三家选择医疗服务',
    open_enrollment_bar_enroll_by_text: '报名截止日期',
    carousel_prescriptions_text: '减少常规处方药的支出',
    text_note: {
      contentful_name: '[DEFAULT] Text Note',
      short_text: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      long_text: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '您提供的内容为空,没有需要翻译的文本。请提供需要从英语(美国)翻译成简体中文(中国)的具体内容。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      button_text: '阅读更多',
    },
    carousel_view_all_button: '查看全部',
    hero: {
      contentful_name: '[default] Unified Landing Hero',
      title: '{x}可以帮助您快速选择医疗计划。',
      cta_button: '让我们开始吧。',
      continue_as_guest_button: '以游客身份开始',
      login_or_signup_button: '登录或注册',
      login_signup_description: '保存进度,获取奖励提示等更多功能!',
      continue_as_guest_description: '不保存您的进度。',
      authenticated_header: '欢迎,{x}!',
      unauthenticated_header: '欢迎!',
      title_primary: '选择您的最佳福利',
      title_trailing_emphasis: '充满信心',
      subheader: 'ALEX帮助您找到适合自己需求的计划并最大化节省开支,无需复杂计算。',
      uat_no_login_header: '为获得最佳审阅体验,请勿登录。',
      uat_no_login_message:
        '登录状态下测试多个场景可能会导致信息冲突。如果您登录后发现异常,请退出登录后重试。',
      alex_explanation_header: 'ALEX的工作原理',
      alex_profile_explanation: '回答几个关于您的医疗保健预算和需求的问题,例如就医次数和处方药。',
      alex_plan_selection_explanation: 'ALEX会帮助您比较各种计划,让您能够自信地选择最优惠的最佳保障方案。',
      secondary_cta_header_primary: '准备好交流',
      secondary_cta_header_trailing_emphasis: '与ALEX一起',
      secondary_cta_header_final_punctuation: '?',
      secondary_cta_message: 'ALEX为您提供所需的洞察,帮助您选择最佳福利,让您不必担心是否获得了所需的保障。',
      marketing_carousel_quotes: [
        {
          startText:
            'Learning about insurance can be daunting, but this was a helpful way to digest it all.”',
          quoteAuthor: 'Unsolicited praise',
        },
        {
          startText: 'ALEX was the most helpful tool. I’ve never had my benefits so clearly explained”',
          quoteAuthor: 'A real quote',
        },
        {
          bigText: '12 minutes',
          endText: 'or less',
          startText: 'ALEX delivers most people their benefits recommendations in',
        },
        {
          startText: 'This made choosing my plan extremely easy and clear.”',
          quoteAuthor: 'A guy who listened to ALEX',
        },
        {
          bigText: '85%',
          endText: 'of people understand their benefits better after talking to ALEX',
        },
        {
          startText: 'I liked the feeling of having someone to talk to about this”',
          quoteAuthor: 'Actual feedback',
        },
        {
          bigText: 'Million',
          endText: 'people trusted ALEX to help them choose their benefits in 2024',
          startText: 'Over a',
        },
      ],
    },
  },
};
